export default `
	mutation splitAppointment($docId:ID!,$creationTimestamp:AWSDateTime!){
			splitAppointment(docId:$docId,creationTimestamp:$creationTimestamp)
		}
	`